export default __webpack_public_path__ + "static/media/logo4.a0ca76d8.png";